import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { formatPrice, prop, ZemplinLoaderWrapper } from '../../..';
import { TableWrapper } from '../General/TableWrapper';
import { TableRow, SecondTableTh, TableThSubHeader } from '../General/Table';
import { DsiBackorderRow as BackorderRow } from './BackorderRow';
import { Filters } from './Invoices';
import { Select } from '../../Zemplin/General/Select';
import { DsiSerialNumberRow } from './SerialNumberRow';
import { FormInput } from '../Form/FormInput';
import { StyledInput } from '../Auth/WarehouseRegisterForm';
import { Button } from '../General/Button';
import { DsiSerialNumberTab } from './SerialNumberTab';

interface Props {
  serialNumbers: any;
  infoContent: any;
  isFetching: boolean;
  handleAddSerialNumber: any;
  handleApplyBenefit: any;
  addSerialNumberError: string;
  user: any;
}

function SerialNumber({
  serialNumbers,
  infoContent,
  isFetching,
  handleAddSerialNumber,
  handleApplyBenefit,
  addSerialNumberError,
  user,
}: Props) {
  const [newSerialNumber, setNewSerialNumber] = React.useState<string>('');

  const columns = [
    { name: __('Produkt') },
    { name: __('Sériové číslo') },
    { name: '' },
  ];

  const headers =
    columns &&
    columns.map((item: any) => (
      <SecondTableTh
        width={item.width}
        minWidth={item.minWidth}
        align={item.align || 'left'}
        key={item.name}
      >
        {item.name}
        <TableThSubHeader>
          {item.secondLine && item.secondLine}
        </TableThSubHeader>
      </SecondTableTh>
    ));
  
  /*
  const serialNumberRows =
    serialNumbers &&
    serialNumbers.map(o => (
      <DsiSerialNumberRow
        serialNumber={o}
        handleApplyBenefit={handleApplyBenefit}
      />
    ));
  */

  const serialNumberTabs =
    serialNumbers &&
    serialNumbers.map(o => (
      <DsiSerialNumberTab
        serialNumber={o}
        handleApplyBenefit={handleApplyBenefit}
      />
    ));

  return (
    <Wrapper>
      {isFetching ? (
        <ZemplinLoaderWrapper height={500} />
      ) : (
        <>
          <NewSerialNumberWrapper>
            <NewSerialNumberWrapperForm>
              <StyledInputCustom marginBottom={24}>
                <FormInput
                  label={__('Sériové číslo')}
                  name={'serial_number'}
                  required={true}
                  type="text"
                  marginBottom={0}
                  onChange={e => setNewSerialNumber(e.target.value)}
                  validMessage={addSerialNumberError}
                  maxWidth={100}
                  maxWidthPx={1024}
                />
              </StyledInputCustom>

              <AddSerialNumberButton
                onClick={() => handleAddSerialNumber(newSerialNumber)}
              >
                {__('Pridať')}
              </AddSerialNumberButton>
            </NewSerialNumberWrapperForm>
            <InfoContent> 
                {infoContent?<>
                  <a href={`/${infoContent.url}`} target='_blank'> {infoContent.name} </a>
                </>:<></>}  
            </InfoContent>
          </NewSerialNumberWrapper>
          
          <div>
            <ProductsCardWrapper visible={true}>
              {serialNumberTabs}
            </ProductsCardWrapper>
          </div>
         
          {/* 
          <TableWrapper
            tableHasBorder={true}
            tableHasBoxShadow={true}
            noItemsText={__('Nenašli sa žiadne sériové čísla')}
            headers={headers}
            footers={[]}
            rows={serialNumberRows}
            overflowX={true}
          />
          */}
        </>
      )}
    </Wrapper>
  );
}


const ProductsCardWrapper = styled(FlexRow)<{ visible: boolean }>`
  margin: ${rem(32)} 0px;
  grid-template-columns: repeat(auto-fill, minmax(${rem(260)}, 1fr));
  gap: 1rem;
  align-items: center;
  grid-auto-rows: minmax(1rem, auto);
  display: grid;
`;

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const Wrapper = styled(FlexRow)`
  flex-flow: column wrap;
  margin-bottom: ${rem(24)};
  animation: ${animateIn} 0.2s ease;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
      margin: 0;
      margin-bottom: ${({ visible }) => (visible ? rem(32) : 0)};
      margin-right: -${rem(16)};
  `};
`;

const AddSerialNumberButton = styled(Button)`
  height: max-content;
  margin-top: ${rem(28)};
  margin-left: ${rem(30)};

  ${({ theme }) => theme.mediab.m810`
    margin-top: 0px;
    margin-left: 0px;
    margin-bottom: ${rem(30)};
  `};

`;

const NewSerialNumberWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const NewSerialNumberWrapperForm = styled.div`
  display: flex;
  flex-direction: row;

  ${({ theme }) => theme.mediab.m810`
    flex-direction: column;
  `};
`

const StyledInputCustom = styled(StyledInput)`
  ${({ theme }) => theme.mediab.m810`
      max-width: 100%;
      margin-bottom: ${rem(12)};
  `};
`

const FormInputCustom = styled(FormInput)`
  
`


const InfoContent = styled.div`
`

export { SerialNumber as DsiSerialNumber };
